import axios from 'axios';
import Utility from '@/common/UtilityFunctions.js';

export const state = {
  isOnPage: false,
  vueModel: null,
  contentLoaded: null,
  stepOne: false,
  stepTwoAccepted: false,
  stepTwoDeclined: false,
  showModalCloseButton: false,
  clickedToOpenModal: false,
  initialConsent: null,
  errorModalVisible: false
};

export const mutations = {
  setVueModel(state, payload) {
    state.vueModel = payload;
    state.contentLoaded = true;
    state.initialConsent = state.vueModel.CprConsentTemplateModel.HasAcceptedCprConsent;
  },
  setContentLoaded(state, payload) {
    state.contentLoaded = payload;
  },
  setStepOne(state, payload) {
    state.stepOne = payload;
  },
  setStepTwoAccepted(state, payload) {
    state.stepTwoAccepted = payload;
  },
  setStepTwoDeclined(state, payload) {
    state.stepTwoDeclined = payload;
  },
  setModalShowCloseButton(state, payload) {
    state.showModalCloseButton = payload;
  },
  setClickedToOpenModal(state, payload) {
    state.clickedToOpenModal = payload;
  },
  setInitialConsent(state, payload) {
    state.initialConsent = payload;
  },
  setHasAcceptedCprConsent(state) {
    state.vueModel.CprConsentTemplateModel.HasAcceptedCprConsent = state.initialConsent;
  },
  updateHasAcceptedCprConsent(state, payload) {
    state.vueModel.CprConsentTemplateModel.HasAcceptedCprConsent = payload;
  },
  setShowCprConsentModal(state, payload) {
    state.vueModel.ShowCprConsentModal = payload;
  },
  setErrorModalVisible(state, payload) {
    state.errorModalVisible = payload;
  },
  setIsOnPage(state, payload) {
    state.isOnPage = payload;
  }
};

export const actions = {
  async setInitialModel({ commit }, payload) {
    await axios
      .get(Utility.constants().API.cpr_consent + payload)
      .then((response) => {
        commit('setVueModel', response.data);
      })
      .catch((err) => {
        commit('setContentLoaded', false);
        Utility.logError(err, this);
      });
  },
  async submitStepOne({ commit, state, dispatch }) {
    if (!state.vueModel.CprConsentTemplateModel.HasAcceptedCprConsent) {
      commit('setStepOne', false);
      commit('setStepTwoDeclined', true);
      dispatch('registerEvent', 'cpr-consent-modal-no-and-send');
      return false;
    }

    const body = state.vueModel.CprConsentTemplateModel;
    await axios
      .post(Utility.constants().API.cpr_consent_submit, body)
      .then(() => {
        commit('setStepOne', false);
        commit('setStepTwoAccepted', true);
        commit('setInitialConsent', state.vueModel.CprConsentTemplateModel.HasAcceptedCprConsent);
        dispatch('registerEvent', 'cpr-consent-modal-yes-and-send');
      })
      .catch((err) => {
        dispatch('showErrorModal');
        Utility.logError(err, this);
      });
  },
  async submitStepTwoDeclined({ commit, dispatch, state }) {
    const body = state.vueModel.CprConsentTemplateModel;
    await axios
      .post(Utility.constants().API.cpr_consent_submit, body)
      .then(() => {
        commit('setStepTwoDeclined', false);
        commit('setInitialConsent', state.vueModel.CprConsentTemplateModel.HasAcceptedCprConsent);
        dispatch('registerEvent', 'cpr-consent-modal-no-confirmed');
      })
      .catch((err) => {
        dispatch('showErrorModal');
        Utility.logError(err, this);
      });
  },
  closeModalsByCross({ commit }) {
    commit('setStepOne', false);
    commit('setStepTwoAccepted', false);
    commit('setStepTwoDeclined', false);
    commit('setHasAcceptedCprConsent');
    commit('setErrorModalVisible', false);
  },
  regretStepTwoDeclined({ commit }) {
    commit('setStepTwoDeclined', false);
    commit('setStepOne', true);
  },
  setStepOne({ commit }, payload) {
    commit('setStepOne', payload);
  },
  openModalByClickOnMemberInfo({ commit, state }, payload) {
    if (state.vueModel !== null) {
      commit('setShowCprConsentModal', payload);
      commit('setStepOne', payload);
      commit('setModalShowCloseButton', payload);
      commit('setClickedToOpenModal', payload);
    }
  },
  registerEvent({ state, dispatch }, eventStr) {
    dispatch(
      'Events/register',
      {
        event: eventStr,
        id: 'cprConsentModal',
        vm: state.vueModel
      },
      {
        root: true
      }
    );
  },
  showErrorModal({ commit }) {
    commit('setStepOne', false);
    commit('setStepTwoDeclined', false);
    commit('setErrorModalVisible', true);
  },
  setIsOnPage({ commit }, payload) {
    commit('setIsOnPage', payload);
  }
};

export const getters = {
  showModals(state) {
    if (!state.contentLoaded) return false;

    return state.contentLoaded && (state.vueModel.ShowCprConsentModal || state.clickedToOpenModal);
  },
  showMainModal(state) {
    if (!state.contentLoaded) return false;

    return (
      state.vueModel.ShowCprConsentModal &&
      (state.initialConsent === null || state.clickedToOpenModal)
    );
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
